import { useQuery } from "@tanstack/react-query";
import {
	type GetShiftsParams,
	getShiftsData,
} from "../repositories/ShiftsRepository";

type UseShiftsDataParams = Omit<GetShiftsParams, "signal">;

export const useShiftsData = ({ start, end }: UseShiftsDataParams) =>
	useQuery({
		queryKey: ["shiftsData", start, end],
		queryFn: ({ signal }) => getShiftsData({ start, end, signal }),
		enabled: !!start && !!end,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
